import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REP_API } from '@constants/index';
import type { RootState } from '@store/index';

/**
 * Base RTK Query service for palmetto-typescript-rep-api. Each feature folder
 * injects its endpoints (services/<domain>Api.ts) so the cache, tags and the
 * Authorization header (raw Cognito id_token, no Bearer prefix - the API
 * Gateway Cognito authorizer validates it) are shared.
 */
export const repApi = createApi({
  reducerPath: 'repApi',
  keepUnusedDataFor: 30,
  baseQuery: fetchBaseQuery({
    baseUrl: REP_API,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).app.jwtToken;
      if (token) headers.set('Authorization', token);
      return headers;
    },
  }),
  tagTypes: [
    'Groups',
    'Lcert',
    'LcertYears',
    'LcertNotifications',
    'Equipment',
    'EquipmentUnassigned',
    'Organizations',
    'EquipmentNotifications',
    'Calibration',
    'Redistribution',
    'Agreement',
    'Plants',
    'Exercise',
    'Capability',
    'CapabilityTarget',
    'Milestone',
    'TrainingClass',
    'TrainingAttendees',
    'TrainingStatus',
    'FileLibrary',
    'DocketCounts',
  ],
  endpoints: () => ({}),
});

/** Shared helper for query-string building (drops undefined/null/empty). */
export const qs = (params: Record<string, unknown>): string => {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue;
    search.set(key, String(value));
  }
  const text = search.toString();
  return text ? `?${text}` : '';
};
